import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Icon from 'react-icons-kit'
import { clock, briefcase, edit2 as editPencil } from 'react-icons-kit/feather'

import { setJson, setOriginalJson } from '../../../store/actions/setJson'
import invoiceStyles from './InvoiceList.module.scss'

/**
* @author zilahir
* @function InvoiceList
* */

const InvoiceList = props => {
	const { date, title, isOdd, jsonValue, shallClosePane } = props
	const [isEditButtonVisible, setEditButtonVisible] = useState(false)
	const dispatch = useDispatch()
	function handleOnFocus() {
		setEditButtonVisible(true)
	}

	function handleFocusOut() {
		setEditButtonVisible(false)
	}
	function selectInvoice(json) {
		dispatch(setJson(JSON.parse(json)))
		dispatch(setOriginalJson(JSON.parse(json)))
		shallClosePane(false)
	}
	function formatDate(d) {
		const invoiceDate = new Date(d)
		const dateObject = {
			year: invoiceDate.getFullYear(),
			month: invoiceDate.getMonth() + 1,
			day: invoiceDate.getDay(),
		}
		return `${dateObject.year}-${dateObject.month}-${dateObject.day}`
	}
	return (
		<div
			className={invoiceStyles.invoiceContainer}
			onMouseEnter={() => handleOnFocus()}
			onMouseLeave={() => handleFocusOut()}
			onClick={() => selectInvoice(jsonValue)}
			role="button"
			tabIndex={-1}
			onKeyPress={() => true}
		>
			<div className={classNames(
				invoiceStyles.oneTableRow,
				invoiceStyles[isOdd],
			)}
			>
				<div className={invoiceStyles.metaContainer}>
					<div>
						<div className={invoiceStyles.icon}>
							<Icon icon={clock} size="2em" />
						</div>
						<span>
							{
								formatDate(date)
							}
						</span>
					</div>
					<div>
						<div className={invoiceStyles.icon}>
							<Icon icon={briefcase} size="2em" />
						</div>
						<span>
							{title || 'n/a'}
						</span>
					</div>
				</div>
				<div className={invoiceStyles.btnContainer}>
					<button
						className={classNames(
							invoiceStyles.button,
							!isEditButtonVisible ? invoiceStyles.hidden : null,
						)}
						type="button"
					>
						<Icon icon={editPencil} size="1.5em" />
						edit
					</button>
				</div>
			</div>
		</div>
	)
}

InvoiceList.defaultProps = {
	isOdd: null,
	jsonValue: null,
}

InvoiceList.propTypes = {
	date: PropTypes.string.isRequired,
	isOdd: PropTypes.string,
	jsonValue: PropTypes.string,
	shallClosePane: PropTypes.func.isRequired,
	title: PropTypes.string.isRequired,
}

export default InvoiceList
